export enum ApiErrorMessage {
  NO_CURRENT_RUN_FOUND = 'NO_CURRENT_RUN_FOUND',
  API_CALL_IS_LOCKED = 'API_CALL_IS_LOCKED',
}

export enum ItemLocation {
  GLOBAL_BAG_SLOT = 'GLOBAL_BAG_SLOT',
  GLOBAL_INVENTORY = 'GLOBAL_INVENTORY',
  HERO_BAG_SLOT = 'HERO_BAG_SLOT',
  HERO_INVENTORY = 'HERO_INVENTORY',
  EQUIPMENT_FIGURE = 'EQUIPMENT_FIGURE',
}
